<script setup lang="ts">
// TODO: Move to 0.index.yml (maybe even a better spot??)
const columns = [{
  label: 'Hosting Plans',
  children: [{
    label: 'Minecraft',
    to: '/hosting/minecraft'
  }, {
    label: 'Hytale',
    to: '/hosting/hytale'
  }, {
    label: 'Rust',
    to: '/hosting/rust'
  }, {
    label: 'Garry’s Mod',
    to: '/hosting/gmod'
  }]
}, {
  label: 'Company',
  children: [{
    label: 'About Us',
    to: '/about'
  }, {
    label: 'Blogs',
    to: '/blog'
  }, {
    label: 'News',
    to: '/news'
  }, {
    label: 'Affiliate',
    to: '/affiliate'
  }, {
    label: 'Careers',
    to: '/careers'
  }]
}, {
  label: 'Support',
  children: [{
    label: 'Knowledge',
    to: '/knowledge-base'
  }, {
    label: 'Contact Us',
    to: '/contact'
  }, {
    label: 'Status',
    to: 'https://status.velarahosting.com'
  }]
}, {
  label: 'Compare',
  children: [{
    label: 'vs Shockbyte',
    to: '/compare/shockbyte'
  }, {
    label: 'vs BisectHosting',
    to: '/compare/bisecthosting'
  }, {
    label: 'vs Apex Hosting',
    to: '/compare/apex'
  }, {
    label: 'vs Nodecraft',
    to: '/compare/nodecraft'
  }, {
    label: 'vs Modrinth',
    to: '/compare/modrinth'
  }, {
    label: 'vs Minecraft Realms',
    to: '/compare/realms'
  }]
}, {
  label: 'Legal',
  children: [{
    label: 'Privacy Policy',
    to: '/legal/privacy'
  }, {
    label: 'Terms Of Service',
    to: '/legal/tos'
  }, {
    label: 'Uptime SLA',
    to: '/legal/sla'
  }]
}]

// TODO: Move to 0.index.yml
const socials = {
  instagram: 'VelaraHosting',
  twitter: 'VelaraHosting',
  discord: 'VelaraHosting',
  linkedin: 'VelaraHosting',
  youtube: 'VelaraHosting'
}
</script>

<template>
  <UFooter
    :ui="{
      top: 'border-b border-white/10'
    }"
    class="bg-[#0E120F]/50 backdrop-blur-md"
  >
    <template #top>
      <UContainer>
        <UFooterColumns
          :columns="columns"
          :ui="{ label: 'font-supercell uppercase tracking-[-0.3px] text-white mb-6', link: 'text-[#a8a8a8] text-base hover:text-white transition-colors py-0' }"
        >
          <template #left>
            <div class="flex flex-col gap-4 min-w-75">
              <div class="flex items-center gap-3">
                <div class="h-10 w-12.75 relative rounded-[5px] overflow-hidden">
                  <img
                    src="https://cdn.velarahosting.com/logos/v.png"
                    alt="Velara"
                    class="absolute h-[188%] left-[-31%] top-[-14%] max-w-none"
                  >
                </div>
                <span class="font-supercell text-white text-xl uppercase tracking-tight text-shadow-sm">Velara Hosting</span>
              </div>
            </div>
          </template>
        </UFooterColumns>
      </UContainer>
    </template>

    <template #left>
      <p class="text-white text-base">
        © {{ new Date().getFullYear() }} Velara Hosting. All rights reserved.
      </p>
    </template>

    <template #right>
      <div class="flex items-center gap-2">
        <UButton
          :to="`https://instagram.com/${socials.instagram}`"
          target="_blank"
          icon="i-simple-icons-instagram"
          aria-label="Instagram"
          color="neutral"
          variant="ghost"
          class="size-10 flex items-center justify-center rounded-[10px]"
        />
        <UButton
          :to="`https://twitter.com/${socials.twitter}`"
          target="_blank"
          icon="i-simple-icons-x"
          aria-label="X"
          color="neutral"
          variant="ghost"
          class="size-10 flex items-center justify-center rounded-[10px]"
        />
        <UButton
          :to="`https://discord.gg/${socials.discord}`"
          target="_blank"
          icon="i-simple-icons-discord"
          aria-label="Discord"
          color="neutral"
          variant="ghost"
          class="size-10 flex items-center justify-center rounded-[10px]"
        />
        <UButton
          :to="`https://linkedin.com/in/${socials.linkedin}`"
          target="_blank"
          icon="i-simple-icons-linkedin"
          aria-label="LinkedIn"
          color="neutral"
          variant="ghost"
          class="size-10 flex items-center justify-center rounded-[10px]"
        />
        <UButton
          :to="`https://youtube.com/@${socials.twitter}`"
          target="_blank"
          icon="i-simple-icons-youtube"
          aria-label="YouTube"
          color="neutral"
          variant="ghost"
          class="size-10 flex items-center justify-center rounded-[10px]"
        />
      </div>
    </template>
  </UFooter>
</template>
